/**
 * 完整版节流函数
 * @param {Function} func - 要节流的函数
 * @param {number} delay - 延迟时间(ms)
 * @param {Object} options - 配置
 * @param {boolean} options.leading - 是否立即执行
 * @param {boolean} options.trailing - 是否延迟执行
 */
export const throttle = function (func, delay, options = { leading: true, trailing: true }) {
    let timer = null
    let lastTime = 0
    
    return function(...args) {
      const now = Date.now()
      
      // 首次执行
      if (!lastTime && !options.leading) {
        lastTime = now
      }
      
      const remaining = delay - (now - lastTime)
      
      if (remaining <= 0) {
        // 时间到了，执行
        if (timer) {
          clearTimeout(timer)
          timer = null
        }
        lastTime = now
        func.apply(this, args)
      } else if (!timer && options.trailing) {
        // 还没到时间，设置定时器
        timer = setTimeout(() => {
          lastTime = options.leading ? Date.now() : 0
          timer = null
          func.apply(this, args)
        }, remaining)
      }
    }
  }

